import { Alert, AlertTitle } from '@mui/material';

// Beta disclaimer shown atop the CFI report content (editor + viewer). CFI is
// still being refined, so we flag that scores and findings may change and point
// users to the Support button in the sidebar to send feedback. Mirrors the
// "Beta" chip on the CFI tab in ContractDetailDrawer.
export const CfiBetaNotice = () => (
  <Alert severity="info" sx={{ mb: 2 }}>
    <AlertTitle>ContractIQ is in beta</AlertTitle>
    Scores and findings are still being refined and may change. We&rsquo;d love your feedback — send
    it to us through the Support button in the sidebar.
  </Alert>
);
